<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
  <div
    class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="signupfrom" (ngSubmit)="onSave()">
      <h1 class="heading">
        Add
      </h1>
      <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <!-- name -->
        <div class="space-y-1">
          <label class="subheading">
            Name <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="name" type="text" />
            </div>
            <div *ngIf="submitted && form.name.errors">
              <p *ngIf="form.name.errors.required" class="pt-1 text-red-600 text-xs">
                Name is required
              </p>
            </div>
          </div>
        </div>
        <!-- email -->
        <div class="space-y-1">
          <label class="subheading">
            Email <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="email" type="email" />
            </div>
            <div *ngIf="submitted && form.email.errors">
              <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                Email is required
              </p>
              <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                Invalid Email format
              </p>
            </div>

          </div>
        </div>
        <!-- Contact -->
        <div class="space-y-1">
          <label class="subheading">
            Contact Number <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="phoneNumber" type="text" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
            </div>
            <div *ngIf="submitted && form.phoneNumber.errors">
              <p *ngIf="form.phoneNumber.errors.required" class="pt-1 text-red-600 text-xs">
                Contact Number is required
              </p>
                <p *ngIf="submitted && (form.phoneNumber.errors?.minlength || form.phoneNumber.errors?.maxlength)"
                  class="pt-1 text-red-600 text-xs">
                  Minimum 10 digits are required and maximum 13 digits are allowed
                </p>
            </div>

          </div>
        </div>

          <!-- name -->
        <div class="space-y-1">
          <label class="subheading">
            Person Contact Number
          </label>
          <div>
            <div>
              <input formControlName="contactNumber" type="text" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
            </div>
            <div *ngIf="submitted && form.contactNumber.errors">
              <p *ngIf="submitted && (form.contactNumber.errors?.minlength || form.contactNumber.errors?.maxlength)"
                class="pt-1 text-red-600 text-xs">
                Minimum 10 digits are required and maximum 13 digits are allowed
              </p>
            </div>
          </div>
        </div>
        <!-- address -->
        <ng-container formGroupName="address">

          <div class="space-y-1">
            <label class="subheading">
              Address <span class="text-red-600">*</span>
            </label>
            <div>
              <div>
                <input googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeAddress()" formControlName="name" name="address"
                  placeholder="Enter the address" id="address" type="text" />
              </div>
             
                <div *ngIf="submitted">
                  <div class="error">
                    <p *ngIf="address.get('name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                      Address is required
                    </p>
                    <p *ngIf="address?.errors?.invalidAddress"
                      class="mt-2 text-red-600 text-xs">
                      Invalid address (select from the dropdown)
                    </p>
                  </div>
                </div>

            </div>
          </div>
          <div class="space-y-1">
            <label class="subheading">
              City <span class="text-red-600">*</span>
            </label>
            <div>
              <div>
                <input formControlName="city" name="city" id="city" type="text" />
              </div>
              <div *ngIf="submitted && address.get('city')?.errors">
                <p *ngIf="address.get('city')?.errors?.required"
                  class="pt-1 text-red-600 text-xs">
                  City is required
                </p>
              </div>

            </div>
          </div>
          <div class="space-y-1">
            <label class="subheading">
              State <span class="text-red-600">*</span>
            </label>
            <div>
              <div>
                <input formControlName="state" name="state" id="state" type="text" />
              </div>
              <div *ngIf="submitted && address.get('state')?.errors">
                <p *ngIf="address.get('state')?.errors?.required"
                  class="pt-1 text-red-600 text-xs">
                  State is required
                </p>
              </div>

            </div>
          </div>

          <!-- <div class="sm:col-span-2" formGroupName="startingPointAddress">
            <label for="address" class="block text-sm font-medium text-main-secondary">Garage Address</label>
            <div class="mt-1">
              <input type="text" google-place formControlName="address" (onSelect)="setGarageAddress($event)"
                name="address" id="address" />
            </div>
            <div *ngIf="(addressForm.address.errors || (addressForm.latitude.value === 0 && addressForm.latitude.value === 0 )) && submitted">
              <div *ngIf="(addressForm.address.errors && addressForm.address.errors.required) || (addressForm.latitude.value === 0 && addressForm.latitude.value === 0 )" class="error">
                <p class="mt-2 text-xs text-main-danger">
                  Garage Address is required
                </p>
              </div>
            </div>
  
          </div> -->
        </ng-container>

        <!-- type -->


        <!-- <div class="space-y-1">
          <label class="subheading">
            Type
          </label>
          <div>
            <div>
              <select formControlName="type">
                <option value="">Select Type</option>
                <option value="company">Company</option>
              </select>
            </div>
            <div *ngIf="submitted && form.type.errors">
              <p *ngIf="form.type.errors.required" class="pt-1 text-red-600 text-xs">
                Type is required
              </p>
            </div>
  
  
          </div>
        </div> -->

        <!-- Timezone -->



        <div class="space-y-1">
          <label class="subheading">Time Zone</label>
          <div>
            <select formControlName="timeZone">
              <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
            </select>
            <div *ngIf="submitted && form.timeZone.errors">
              <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                Time Zone is required
              </p>
            </div>
          </div>
        </div>


        <!-- webURL -->

        <div class="space-y-1">
          <label class="subheading">
            Web URL
          </label>
          <div>
            <div>
              <input formControlName="webURL" type="text" />
            </div>

            <!-- <div *ngIf="submitted && form.webURL.errors">
              <p *ngIf="form.webURL.errors.required" class="pt-1 text-red-600 text-xs">
                Web URL is required
              </p>
            </div> -->

          </div>
        </div>

        <!-- State  -->
        <!-- <ng-container formGroupName="address">
  
           
         </ng-container> -->

        <!-- Space type(s) -->
        <div class="space-y-1">
          <label class="subheading">Space Type(s) <span class="text-red-600">*</span></label>
          <div>
            <ng-select [ngModelOptions]="{standalone: true}" [items]="spacetypes" bindLabel="title" bindValue="title"
              [(ngModel)]="selectedServices" [multiple]="true" [clearable]="false" [closeOnSelect]="false"
              placeholder="Select Space Type(s)" [searchable]="true">
            
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <input type="checkbox" [checked]="selectedServices?.includes(item.title)" (click)="$event.stopPropagation()"
                  (change)="toggleServiceSelection(item.title)" />
                {{ (item.title) | uppercase }}
              </ng-template>
            </ng-select>
            <!-- Validation Message -->
            <div *ngIf="submitted && selectedServices?.length === 0">
              <p *ngIf="form.services?.errors?.required" class="pt-1 text-red-600 text-xs">
                Space Type(s) are required
              </p>
            </div>
          </div>
        </div>



        <!-- <div class="sm:col-span-2">
          <label for="tripReason" class="block text-sm font-medium text-main-secondary">Appointment Type </label>
          <div class="mt-1">
            <ng-select [items]="tripPurposeList" formControlName="tripReason" [clearable]="false" [multiple]="true"
              [closeOnSelect]="false" bindValue="title" bindLabel="title" placeholder="-- Select Appointment Type --"
              class="p-0 form-control block w-full rounded-md text-main-secondary placeholder:text-main-light border border-main-base shadow-sm focus:border-main-primary focus:ring-main-primary text-sm"
              [searchable]="true">
  
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                  [ngModel]="item$.selected" /> {{item.title}}
              </ng-template>
            </ng-select>
          </div>
          <div *ngIf="form.tripReason.errors && submitted">
            <div *ngIf="form.tripReason.errors.required" class="error">
              <p class="mt-2 text-xs text-main-danger font-bold">
                Appointment Type is required
              </p>
            </div>
          </div>
        </div> -->


        <!-- fleet -->
        <div class="space-y-1">
          <label class="subheading">
            Number of Vehicles <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="fleet" type="number" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
            </div>

            <div *ngIf="submitted && form.fleet.errors">
              <p *ngIf="form.fleet.errors.required" class="pt-1 text-red-600 text-xs">
                Number of Vehicles are required
              </p>
            </div>

          </div>
        </div>

        <!-- Drivers -->
        <div class="space-y-1">
          <label class="subheading">
            Number of Drivers <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="drivers" type="number" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
            </div>

            <div *ngIf="submitted && form.drivers.errors">
              <p *ngIf="form.drivers.errors.required" class="pt-1 text-red-600 text-xs">
                Number of Drivers are required
              </p>
            </div>

          </div>
        </div>

        <!-- <div class="space-y-1"></div> -->

        <!-- image -->
        <div class="space-y-1">
          <label class="subheading">Company Logo <span class="text-red-600">*</span></label>
          <div>
            <div class="relative overflow-hidden rounded-full inline-flex mt-1">
              <img [src]="profileImageURL ? profileImageURL : 'assets/images/company-placeholder.png'"
                alt="Profile Image" class="relative h-32 w-32 rounded-full border border-main-base" />
              <label for="Profile"
                class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                <span>Change</span>
                <input #logoInput type="file" accept="image/*" style="width: 100%;" (change)="processFile(logoInput)"
                  type="file" id="Profile" name="Profile Image"
                  class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
              </label>
            </div>
            <div *ngIf="form.profileImageURL.errors && submitted">
              <div *ngIf="form.profileImageURL.errors.required" class="error">
                <p class="mt-2 text-red-600 text-xs">
                  Company Logo is required
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex justify-end gap-4">
        <!-- <button class="btn-outline btn-outline-secondary">
              Reset
          </button> -->
        <button type="submit" class="btn btn-secondary">
          Create
        </button>
      </section>

    </form>
  </div>
</div>